import React from "react";
import { useSelector } from "react-redux";
import { DashSel } from "@/features/dashboard";
import Loader from "@/components/Loader";

import BenchmarkAnalysis from "./BenchmarkAnalysis";
import Performance from "./Performance";
import styles from "./styles.less";


export default () => {
  const isLoading = useSelector(DashSel.isDashboardLoading);

  return isLoading ? (
    <Loader />
  ) : (
    <div className={styles.dashboard}>
      <Performance />
      <BenchmarkAnalysis />
    </div>
  );
};
